<template>
  <div className="post">
    <div className="loading">
      Loading...
    </div>
  </div>
</template>
<script>
import axios from 'axios'

export default {
  name: "Auth",
  mounted() {
    this.getToken()
  },
  methods: {
    getToken() {
      const token = localStorage.getItem('bearer')
      axios.get(`${this.$api}/auth/accessToken`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }).then((response) => {
        window.location.href = `${this.$coy}/users/login/${response.data.accessToken}`
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Account/Auth.vue